export const StatusFilter = [
    { status: 'New Orders', value: 'NEW_ORDERS' },
    { status: 'Pending RTS', value: 'PENDING_RTS' },
    { status: 'Ready To Ship', value: 'READY_TO_SHIP' },
    {status:'Shipped & Delivered', value:'DELIVERED'},
    {status:'Cancelled Orders', value:'CANCELLED'},
];
export const NewOrderHeader = [
    { id: 'orderDate', label: 'Order Date ', minWidth: 170, align: 'center' },
    { id: 'orderId', label: 'Order ID', minWidth: 170, align: 'center' },
    { id: 'category', label: 'Category', minWidth: 170, align: 'center' },
    { id: 'modelName', label: 'Model', minWidth: 200, align: 'center' },
    { id: 'orderValue', label: 'Order Amount', minWidth: 120, align: 'center' },
    { id: 'quantity', label: 'Quantity', minWidth: 120, align: 'center' },
    { id: 'action', label: 'Action', minWidth: 200, align: 'center' },
]
export const pendingRTSHeader = [
    { id: 'orderDate', label: 'Order Date ', minWidth: 170, align: 'center' },
    { id: 'orderId', label: 'Order ID', minWidth: 170, align: 'center' },
    { id: 'category', label: 'Category', minWidth: 170, align: 'center' },
    { id: 'modelName', label: 'Model', minWidth: 200, align: 'center' },
    { id: 'orderValue', label: 'Order Amount', minWidth: 100, align: 'center' },
    { id: 'quantity', label: 'Quantity', minWidth: 120, align: 'center' },
    { id: 'invoice', label: 'Invoice', minWidth: 120, align: 'center' },
    { id: 'shippingLabels', label: 'Shipping Label', minWidth: 120, align: 'center' },
    { id: 'deliveryPartner', label: 'Delivery partner ', minWidth: 120, align: 'center' },
    { id: 'actionRts', label: 'Action ', minWidth: 120, align: 'center' },
]
export const RTSHeader = [
    { id: 'orderDate', label: 'Order Date ', minWidth: 170, align: 'center' },
    { id: 'orderId', label: 'Order ID', minWidth: 170, align: 'center' },
    { id: 'category', label: 'Category', minWidth: 170, align: 'center' },
    { id: 'modelName', label: 'Model', minWidth: 200, align: 'center' },
    { id: 'orderValue', label: 'Order Amount', minWidth: 120, align: 'center' },
    { id: 'quantity', label: 'Quantity', minWidth: 120, align: 'center' },
    { id: 'invoice', label: 'Invoice', minWidth: 120, align: 'center' },
    { id: 'shippingLabels', label: 'Shipping Label', minWidth: 120, align: 'center' },
    { id: 'deliveryPartner', label: 'Delivery partner ', minWidth: 120, align: 'center' },
    { id: 'trackingId', label: 'Tracking Number', minWidth: 120, align: 'center' },
]
export const shippedAndDeliveredHeader = [
    { id: 'orderDate', label: 'Order Date ', minWidth: 170, align: 'center' },
    { id: 'orderId', label: 'Order ID', minWidth: 170, align: 'center' },
    { id: 'category', label: 'Category', minWidth: 170, align: 'center' },
    { id: 'modelName', label: 'Model', minWidth: 200, align: 'center' },
    { id: 'orderValue', label: 'Order Amount', minWidth: 120, align: 'center' },
    { id: 'quantity', label: 'Quantity', minWidth: 120, align: 'center' },
    { id: 'invoice', label: 'Invoice', minWidth: 120, align: 'center' },
    { id: 'trackingId', label: 'Tracking Number', minWidth: 120, align: 'center' },
    { id: 'currentStatus', label: 'Current status', minWidth: 120, align: 'center' },
    { id: 'selfDeliveryAction', label: 'Action', minWidth: 180, align: 'center' },
];
export const cancelledHeader = [
    { id: 'orderDate', label: 'Order Date ', minWidth: 170, align: 'center' },
    { id: 'orderId', label: 'Order ID', minWidth: 170, align: 'center' },
    { id: 'category', label: 'Category', minWidth: 170, align: 'center' },
    { id: 'modelName', label: 'Model', minWidth: 200, align: 'center' },
    { id: 'orderValue', label: 'Order Amount', minWidth: 120, align: 'center' },
    { id: 'quantity', label: 'Quantity', minWidth: 120, align: 'center' },
    { id: 'invoice', label: 'Invoice', minWidth: 120, align: 'center' },
    { id: 'currentStatus', label: 'Current status', minWidth: 120, align: 'center' },
];

export const Category = [
    { label: 'Air Conditioners', value: 'air-conditioner' },
    { label: 'Washing Machines', value: 'Washing-machine' },
    { label: 'Televisions', value: 'televisions' },
    { label: 'Refrigerators', value: 'Refrigerator' },
    { label: 'Mobiles', value: 'Mobiles' },
    { label: 'Kitchen Appliances', value: 'Kitchen Appliances' },
    { label: 'Small Appliances', value: 'Small Appliances' },
    { label: 'Audio', value: 'Audio' },
    { label: 'Personal Care', value: 'Personal Care' },
    { label: 'IT', value: 'IT' },
];

export const PageItems = [
    15,
    25,
    50
]